import React from 'react';
import * as mobxReact from 'mobx-react';
import { FormattedMessage } from 'react-intl';
import OptionsButton from '../../../../global/options-button/options-button';
import { WebinarReportsViewModel } from './webinar-reports.viewmodel';

interface IProps {
    webinarReportsVM: WebinarReportsViewModel;
    connectionLink: string;
    connectionId: string;
    cancelled: boolean;
}

const WebinarReportPresentation = mobxReact.observer((props: IProps) => {
    const {
        connectionLink,
        connectionId,
        cancelled,
        webinarReportsVM
    } = props;

    const {
        isWebinarReportLoading,
        getWebinarAttendeeReport,
        getWebinarRegistrationReport
    } = webinarReportsVM;

    return <OptionsButton
        className='small-button silver-button'
        modifier={['slim', 'confirm-safe']}
        label={isWebinarReportLoading ?
            <FormattedMessage id='oe.common.inProgress' description='Button text' defaultMessage='In progress' />
            : <FormattedMessage id='oe.common.getReport' description='Button text' defaultMessage='Get Report' />
        }
        disabled={isWebinarReportLoading}
        options={[
            {
                label: 'Registration report',
                action: () => getWebinarRegistrationReport(connectionId),
                disabled: !connectionLink || cancelled
            },
            {
                label: 'Attendee report',
                action: () => getWebinarAttendeeReport(connectionId),
                disabled: !connectionLink || cancelled
            },
        ]}
    />;
});

export default WebinarReportPresentation;